module.exports = __webpack_public_path__ + "img/메인좌측배너텔레공지방.728a4856.png";